var O = /* @__PURE__ */ ((_) => (_.ON_GO_BACK = "on_go_back", _))(O || {}), L = /* @__PURE__ */ ((_) => (_.ON_EDIT_AVATAR = "on_edit_avatar", _.ON_EDIT_NICKNAME = "on_edit_nickname", _.ON_CLICK_FOLLOWERS = "on_click_followers", _.ON_CLICK_FOLLOWING = "on_click_following", _.ON_CLICK_TO_FOLLOW = "on_click_to_follow", _.ON_CLICK_TO_UNFOLLOW = "on_click_to_unfollow", _.ON_CLICK_DEALS = "on_click_deals", _.ON_CLICK_MY_DATA = "on_click_my_data", _))(L || {});
export {
  L as ProfileAction,
  O as ProfilePageAction
};
